import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ArrowIcon from '../../UI/Icons/ArrowIcon'
import Typography from '../../UI/Typography'
import { device } from '../../../utils/helpers'
import Step from './Step'
// import { steps } from './'

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  display: block;
  margin-top: 80px;
  ${''/* z-index: 10; */}

  @media ${device.tablet} {
    display: none;
  }
`

const Header = styled.div`
  background: ${props => props.theme.color.bgYellow};
  width: 100%;
  padding: ${props => !props.collapsed && '8px 20px'};
  box-sizing: border-box;
  color: #fff;
  display: flex;
  justify-content: ${props => props.collapsed ? 'space-between' : 'initial'};
`

const Arrow = styled(ArrowIcon)`
  cursor: pointer;
  height: 100%;
`

const ArrowWrapper = styled.div`
  background: ${props => props.theme.color.bgYellow};
  padding: ${props => props.collapsed && '8px 25px'};
`

const Steps = styled.div`
  display: flex;
  background-color: #f3f3f3;
  width: 100%;
  padding: 10px 30px;
  justify-content: space-around;
`

const StepNumber = styled.div`
  font-size: 17px;
  font-family: 'BarlowExtraBold';
  color: ${props => props.visited ? '#4d4d4d' : '#ccc'};
  color: ${props => props.active && '#fca317'};
`

const Items = styled.div`
  height: 700px;
  background-color: #f3f3f3;
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
`

const Total = styled.div`
  background-color: #fca317;
  font-size: 24px;
  font-family: 'BarlowExtraBold';
  color: #fff;
  display: flex;
  justify-content: ${props => props.collapsed ? 'center' : 'space-between'};
  padding: 15px 30px;
`

const Prices = styled.div`
  background-color: #999999;
  font-size: 18px;
  font-family: 'BarlowExtraBold';
  padding: 20px 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: ${props => props.collapsed ? 'center' : 'initial'};
`

const Price = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 5px;
`

class CalculatorSidebar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      collapsed: true
    }
  }

  toggleSidebar () {
    this.setState({ collapsed: !this.state.collapsed })
  }

  render () {
    const { collapsed } = this.state
    const { steps } = this.props
    return (
      <Wrapper>
        <Header collapsed={collapsed}>
          {collapsed && <Steps>
            {steps.map(({ index, active, visited }) => {
              return (
                <StepNumber key={index} active={active} visited={visited}>{index}</StepNumber>
              )
            })}
          </Steps>}
          <ArrowWrapper collapsed={collapsed}>
            <Arrow onClick={this.toggleSidebar.bind(this)} transform={collapsed ? 'rotate(180)' : undefined} width='22' fill='#4d4d4d' />
          </ArrowWrapper>
          {!collapsed && <Typography color='#fff' variant='h3' type='title' style={{ paddingLeft: '25px' }}>DETTAGLI DEL NOLEGGIO</Typography>}
        </Header>
        {!collapsed && <Items>
          {steps.map(({ index, name, active, visited, price, components, selectedComponent }) =>
            <Step
              key={index}
              index={index}
              name={!collapsed && name}
              active={active}
              visited={visited}
              price={!collapsed && price}
              components={!collapsed && components}
              selectedComponent={selectedComponent}
            />
          )}
        </Items>}
        {!collapsed && <Footer>
          <Total collapsed={collapsed}>
            <p>TOTALE</p>
            <p>0 €</p>
          </Total>
          <Prices collapsed={collapsed}>
            <Price>
              <p>TOTALE NETTO</p>
              <p>0 €</p>
            </Price>
            <Price>
              <p>IVA 22.00%</p>
              <p>0 €</p>
            </Price>
          </Prices>
        </Footer>}
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    steps: state.calculator.steps
  }
}

export default connect(mapStateToProps)(CalculatorSidebar)



// WEBPACK FOOTER //
// ./src/components/Calculator/Sidebar/MobileSidebar.js